import { RoutePaths } from '@assembly/constants'
import axios from 'axios'

export const baseURL = process.env.REACT_APP_ENV_API_BASE_URL

export const axiosWithConfig = axios.create({
  baseURL: baseURL,
  withCredentials: true,
})

axiosWithConfig.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && (error.response.status === 401 || error.response.status === 403)) {
      window.location.href = RoutePaths.Root
    }
    return Promise.reject(error)
  }
)

export const axiosWithConfigForAuth = axios.create({
  baseURL: baseURL,
  withCredentials: true,
})

axiosWithConfigForAuth.interceptors.response.use(
  (response) => response,
  (error) => {
    // Don't redirect on 401/403 - let the App component handle it
    // The App component will show the login screen when it catches these errors
    return Promise.reject(error)
  }
)
